import React, { useState, useEffect, useCallback } from 'react';
import { tidyText } from '../../utils/tidyText';
import Header from './Header';
import AnswerCard from './AnswerCard';
import Status from './Status';
import EndQuiz from './EndQuiz';
import './quiz.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.cinebotz.com';
const QUESTIONS_COUNT = 5;

export function Quiz({ user }) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [numCorrect, setNumCorrect] = useState(0);
  const [statusShown, setStatusShown] = useState(false);
  const [currentCorrect, setCurrentCorrect] = useState(false);
  const [qsetid, setQsetid] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/getbotq`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        setQuestions(data);
        setQsetid(data[0]?.questionSetId ?? '');
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const handleAnswer = useCallback(
    (answer) => {
      const current = questions[questionIndex];
      if (!current) return;
      setStatusShown(true);
      const correct = answer === current.correctAnswer;
      setCurrentCorrect(correct);
      if (correct) setNumCorrect((n) => n + 1);
      setTimeout(() => {
        setStatusShown(false);
        setQuestionIndex((i) => (i < QUESTIONS_COUNT - 1 ? i + 1 : -1));
      }, 1250);
    },
    [questions, questionIndex]
  );

  if (loading || questions.length === 0) {
    return (
      <div className="quiz quiz--loading">
        <h1 className="quiz-title quiz-title--loading">Quiz Botz</h1>
        <p className="quiz-tagline">Daily five new cine questions about cinema.</p>
        <div className="quiz-loading" />
        <p className="quiz-loading-text">Loading quiz…</p>
      </div>
    );
  }

  if (questionIndex < 0) {
    return (
      <EndQuiz
        numCorrect={numCorrect}
        user={user}
        qsetid={qsetid}
        qdata={questions}
      />
    );
  }

  const current = questions[questionIndex];
  const question = current.question;
  const answers = current.answers;
  const image = current.image;
  const posters = [...new Set(questions.map((q) => q.image).filter(Boolean))];
  const marqueePosters = [...posters, ...posters];

  return (
    <div className="quiz">
      <main
        className={`quiz-main${image ? ' quiz-main--has-poster' : ''}`}
        style={image ? { '--quiz-poster-bg': `url("${image}")` } : undefined}
      >
        <h1 className="quiz-title">Quiz Botz</h1>
        <p className="quiz-tagline">Daily five new cine questions about cinema.</p>
        <Header>{tidyText(question)}</Header>
        <div className="quiz-answers-wrap">
          <AnswerCard answers={answers} onClick={handleAnswer} />
        </div>
      </main>

      {posters.length > 0 && (
        <div className="quiz-poster-roll" aria-hidden>
          <div className="quiz-poster-roll-track">
            {marqueePosters.map((src, i) => (
              <img
                key={`${src}-${i}`}
                src={src}
                alt=""
                className="quiz-poster-roll-img"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      )}

      {statusShown && <Status correct={currentCorrect} />}
    </div>
  );
}

export default Quiz;
